/**
 * Product imagery used by the shared More Info renderer.
 *
 * `overlay` is reserved for art intentionally composed with quiet space for
 * hero copy. `feature` assets are shown as complete, uncropped visual panels.
 * Products without a raster asset receive a labelled, code-native capability
 * map assembled from their reviewed product content; it is never represented
 * as an application screenshot.
 */
export const PRODUCT_MEDIA = {
  'service-command-centre': {
    src: '/product-more-info/service-command-centre/hero-operations-flow.png',
    placement: 'feature',
    alt: 'A service workshop linked from booking and customer records through jobs, stock, invoicing and payment.',
    caption: 'Operational flow illustration: one connected record follows the work from booking to payment.',
  },
  'website-capture-suite': {
    src: '/product-more-info/website-capture-suite/hero-responsive-capture.png',
    placement: 'overlay',
    position: '68% center',
    alt: 'A website captured across desktop, tablet and phone, with an archive timeline above the devices.',
    caption: 'Representative output: responsive page captures organised into a dated visual record.',
  },
  'file-converter': {
    src: '/product-more-info/file-converter/hero-local-conversion.png',
    placement: 'feature',
    alt: 'Different file formats moving through a local conversion process on a laptop.',
    caption: 'Capability illustration: content is identified first, then only genuine local conversion targets are offered.',
  },
  'virtual-shop': {
    src: '/product-more-info/virtual-shop/hero-catalogue.png',
    placement: 'overlay',
    position: '70% center',
    alt: 'A visual digital catalogue leading to a protected acquisition path.',
    caption: 'Catalogue illustration: browse virtual products, acquire with Shop Credits and keep them in your collection.',
  },
};

export function productMedia(key) {
  return PRODUCT_MEDIA[key] || null;
}
